"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[884],{

/***/ 10884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99878);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88751);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96301);








const GlobalPageFooter = (props)=>{
    const { footer , footerScripting , configData ={}  } = props;
    const [scripts, setScripts] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const { pageIsInteractive  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__.selectGenericState);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const { pageLevelDetails =[]  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getPageLevelScriptsAndStyles)(footerScripting);
        setScripts(pageLevelDetails["pageScripts"]);
    }, [
        footerScripting
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getScriptsAndStyles)(footer);
    }, [
        footer
    ]);
    const eventHandler = {
        store: {},
        callbacks: {
            setGlobalScripts: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__.setGlobalScripts)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__.setGlobalStyles)(item));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            pageIsInteractive && scripts.map((script, i)=>{
                if (script.src) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: script.src,
                    type: script.type,
                    integrity: script.integrity,
                    id: "footerscript-".concat(i)
                }, "footerscript-".concat(i));
                if (!script.src && script.innerHTML) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    id: "footerscriptHtml-".concat(i),
                    strategy: script.isCritical ? "worker" : "lazyOnload",
                    children: "".concat(script.innerHTML)
                }, "footerscriptHtml-".concat(i));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_3__["default"], {
                data: footer,
                count: 0,
                eventHandler: eventHandler,
                fragment: _constants__WEBPACK_IMPORTED_MODULE_7__.FRAGMENT_TYPES.FOOTER,
                configData: configData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (GlobalPageFooter);


/***/ })

}]);